// localStorage / sessionStorage могут быть недоступны (приватный режим, iframe без storage)
function makeStorage(getStore) {
  return {
    get(key, fallback = null) {
      try {
        const raw = getStore().getItem(key);
        return raw == null ? fallback : JSON.parse(raw);
      } catch {
        return fallback;
      }
    },
    set(key, value) {
      try {
        getStore().setItem(key, JSON.stringify(value));
      } catch {
        /* storage недоступен */
      }
    },
    remove(key) {
      try {
        getStore().removeItem(key);
      } catch {
        /* storage недоступен */
      }
    },
  };
}

export const storage = makeStorage(() => window.localStorage);
export const sessionStore = makeStorage(() => window.sessionStorage);

export const progressKey = (videoId) => `vp:pos:${videoId}`;
export const doneKey = (videoId) => `vp:done:${videoId}`;

export function formatTime(sec) {
  if (!sec || !isFinite(sec) || sec < 0) sec = 0;
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  const ss = String(s).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}

export function formatDuration(sec) {
  if (!sec || !isFinite(sec)) return '';
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  if (h) return `${h} ч ${m} мин`;
  if (m) return `${m} мин`;
  return `${Math.floor(sec)} сек`;
}

export function pluralRu(n, one, few, many) {
  const n10 = n % 10;
  const n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return one;
  if (n10 >= 2 && n10 <= 4 && (n100 < 10 || n100 >= 20)) return few;
  return many;
}

export function formatCount(n) {
  return new Intl.NumberFormat('ru-RU').format(n || 0);
}

// «1:23», «83», «1m23s» → секунды
export function parseTimeParam(value) {
  if (!value) return null;
  if (/^\d+$/.test(value)) return parseInt(value, 10);
  const hms = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  if (hms && (hms[1] || hms[2] || hms[3])) {
    return (parseInt(hms[1] || 0, 10) * 3600) + (parseInt(hms[2] || 0, 10) * 60) + parseInt(hms[3] || 0, 10);
  }
  const parts = value.split(':').map((p) => parseInt(p, 10));
  if (parts.length > 1 && parts.every((p) => !Number.isNaN(p))) {
    return parts.reduce((acc, p) => acc * 60 + p, 0);
  }
  return null;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }
}
